import type { OrganizationQuotas, QuotaBudget } from "@t3tools/contracts";

import { i18n } from "../../i18n";
import { formatQuotaRenewal } from "../../quotaPresentation";

const labels = {
  monthly: "settings/monthly_yrw5jb",
  five_hour: "settings/n5Hours_zck8ii",
  weekly: "settings/weekly_sr1mrl",
} as const;

export function quotaBar(usedRatio: number) {
  const percent = Math.max(0, usedRatio * 100);
  return {
    value: Math.min(100, percent),
    label: percent > 100 ? "100%+" : `${Math.round(percent)}%`,
  };
}

function budgetRows(budgets: readonly QuotaBudget[], locale: string, nowMs: number) {
  const t = i18n.getFixedT(locale);
  const kinds = ["monthly", "five_hour", "weekly"] as const;
  return kinds.flatMap((kind) => {
    const budget = budgets.find((entry) => entry.kind === kind);
    if (!budget) return [];
    const date = formatQuotaRenewal(budget.resetsAt, kind, locale, nowMs);
    return [
      {
        kind,
        title: t(labels[kind]),
        renewal: date
          ? t("settings/renews_dnr1jq", { date })
          : t("settings/renewalTimeIsNot_jmo67j"),
        bar: quotaBar(budget.usedRatio),
      },
    ];
  });
}

export function limitsSettingsView(
  quotas: OrganizationQuotas | null,
  locale: string,
  nowMs: number,
) {
  if (quotas === null) return null;
  const t = i18n.getFixedT(locale);
  const number = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });
  return {
    agent: budgetRows(quotas.agent.budgets, locale, nowMs),
    ocr: budgetRows(quotas.ocr.budgets, locale, nowMs),
    storage:
      quotas.storage === null
        ? null
        : {
            label: t("settings/gb_bgw3i1", {
              used: number.format(quotas.storage.usedBytes / 1024 ** 3),
              limit: number.format(quotas.storage.limitBytes / 1024 ** 3),
            }),
            bar: quotaBar(quotas.storage.usedBytes / quotas.storage.limitBytes),
          },
  };
}
